// extracted by mini-css-extract-plugin
module.exports = {"main":"extract__main___2becp"};